import React from 'react';
export default function TriangleBeard({ light, dark }) {
  return (
<><path d="M17.17 23.966c-.766.008-2.5-2.079-4.38-4.868-1.981-2.869 2.647.743 4.387.77 1.432.023 6.148-3.78 4.298-.913-1.839 2.848-3.533 5.002-4.304 5.01z" fill={light}/></>); }
